import { CheckoutState } from '../../state';
import { getApplePayInstance } from './pureSelectors';

export const isApplePayInstanceCreated = (state: CheckoutState) =>
    !!getApplePayInstance(state);
